<template>
  <div class="subView">
    <div class="subView_list">
      <div class="subView_item">
        <div class="title"><span v-if="JSON.stringify(navList) !='{}'">{{navList.columnText}}</span><span style="border: 2px solid #CCCBDB;font-size: 24px;position: relative;top: -4px;margin-left: 20px"></span>
          <span class="text" style="margin-left: 10px" v-if="navList.list.length>0">
                    {{navList.list[1].columnText}}</span>
        </div>
        <div class="btnBox">
          <el-button class="btn" @click="goabout()">免费咨询</el-button>
        </div>
      </div>
      <div class="box-right">
          <el-row :gutter="48">
            <el-col class="subView_top" v-for="(item,index) in List" :key="index" :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-card style="margin-bottom: 30px;width: 350px;height: 510px">
                <div class="card">
                  <img :src="item.img" class="image">
                  <div class="text" style="">
                    <span class="title">{{ item.title }}</span>
                    <div class="content">
                      <span>{{ item.content }}</span>
                    </div>
                  </div>
                  <el-button class="btn" @click="goToUrl(item.href)">购买</el-button>
                </div>
              </el-card>
            </el-col>
          </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
export default {
  name: "mtevidence",
  data(){
    return{
      List:[
        {title:"震动传感器",content:"震动传感器将半埋于地下，可通过运动目标产生的地震动信号识别人、车等多种目标，识别人员行走、挖掘或车辆通过等事件，设备自带无线通信与定位模块，可将探测信息通过网关实时传回后端。",href:"https://ic-item.jd.com/100171565018.html",img:require ("../../assets/purchaseImg/img.png")},
        {title:"图像传感器",content:"用于对布设地域进行视频监控并对视野内目标类别、行为进行识别,设备自带无线通信、定位及电源模块，可通过网关将探测信息实时传回后端。分全彩、红外两种类型 ，昼夜工作。",href:"https://ic-item.jd.com/100138413895.html",img:require ("../../assets/purchaseImg/img_1.png")},
        {title:"声音传感器",content:"采用拾音咪头对布设地域进行监控并对视野内目标类别、行为进行识别，在室外环境下，半径在30米范围内，方位角定位误差不高于10度。",href:"https://ic-item.jd.com/100171936056.html",img:require ("../../assets/purchaseImg/img_2.png")},
        {title:"红外传感器",content:"采用被动红外摄像头对布设地域进行监控并对视野内目标类别、行为进行识别，设备自带无线通信、定位及电源模块，可通过网关将探测信息实时传回后端。",href:"https://ic-item.jd.com/100132077600.html",img:require ("../../assets/purchaseImg/img_3.png")},
        {title:"地磁传感器",content:"采地磁传感器埋设于地下，通过探测周边磁场变化识别周边金属物体的运动情况，设备自带无线通信、定位及电源模块，可通过网关将识别结果实时传回后端。",href:"https://ic-item.jd.com/100111842207.html",img:require ("../../assets/purchaseImg/img_4.png")},
        {title:"自组网网关",content:"采地网关将无线自组网协议数据转换为USB协议数据，可将覆盖地域内传感器信息汇聚至监控终端。",href:"https://ic-item.jd.com/100166108868.html",img:require ("../../assets/purchaseImg/img_5.png")},
      ],
      navList:{},
    }
  },
  created(){
    this.getDataList()
  },
  methods:{
    goToUrl(href) {
      window.open(href);
    },
    goabout(){
      this.$router.push({
        name: 'about'
      })
    },
    getDataList() {
      if(this.$route.query.text){
        axios.post("https://article.chenhaninfo.com/publish-article/sys/column/columnList", {
        }).then(({data}) => {
          if (data && data.code === 0) {
            for(let item of data.list){
              if(item.columnText == "群智协同产品"){
                this.navList=item.list[0]
              }
            }
          } else {
            this.navList = {}
          }
        }).catch(function (error) {
          console.log(error);
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
input[aria-hidden="true"]{
  display: none !important;
}
::v-deep .el-row{
  margin-left: 0 !important;
}
.subView {
  margin-top: 78px;
  background-color: #fff;
  min-width: 1580px;
  width: 100%;
  .subView_list {
    .subView_item {
      background-image: url("../../assets/mtevidence/beijing.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 220px;
      text-align: center;

      .title {
        font-size: 37px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #282B31;
        padding-top: 50px;

        .text {
          font-size: 37px;
          font-weight: 300;
          color: #2D3036;
        }
      }
      .btnBox {
        margin-top: 32px;
      }
      .btn {
        width: 139px;
        height: 39px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 16px;
        background: #0069FD;
        border-radius: 20px;
        margin-top: 29px;
      }
    }
    .box-right{
      width: 80%;
      padding: 30px 0;
      min-height: 220px;
      margin: 0 auto;
    .subView_top{
      .card{
        margin: 0 auto;
        .image{
          width: 270px;
          height: 270px;
          display: block;
          margin: 0 auto;
        }
        .text{
          padding: 18px;
          height: 120px;
          margin: 0 auto;
          .title{
            margin-top: 10px;
          }
          .content{
            margin-top: 5px;
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 5;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
        }
        .btn {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 16px;
          background: #0069FD;
          border-radius: 20px;
          float: right;
          margin-right: 15.7px;
        }
      }
    }
    }
  }
}
</style>
